import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import statuses from "../../const/links";
import { useContext, useState } from "react";
import { RequestContext } from "../../context/request.context";

const UpdateOrder = ({ data, close, updateRows }) => {
  const [status, setStatus] = useState(data.status);
  const { request } = useContext(RequestContext);
  const action = async () => {
    const res = await request(`/order/change-status/${data.id}`, "PUT", status);
    if (res) {
      close();
      updateRows(res);
    }
  };
  return (
    <Box
      sx={{
        padding: "1rem",
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
        width: "100%",
        minWidth: "300px",
      }}
    >
      <Typography variant="h6">Statusni o'zgartirish</Typography>
      <FormControl fullWidth>
        <InputLabel id="select-label">Status</InputLabel>
        <Select
          fullWidth
          labelId="select-label"
          id="select"
          value={status}
          label="Status"
          onChange={(e) => {
            setStatus(e.target.value);
          }}
        >
          {statuses.map((item, index) => {
            return (
              <MenuItem key={index} value={item.value}>
                {item.name}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
      <Button variant="contained" color="primary" onClick={action}>
        Saqlash
      </Button>
    </Box>
  );
};

export default UpdateOrder;
